module.exports = __webpack_public_path__ + "img/module-thumb.1872ec7a.jpg";